import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";
import { setRefreshInterval } from "../../slices/thunk";
import { useDispatch } from "react-redux";


const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  var token = userProfileSession && userProfileSession["access"];
  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    var token = userProfileSession && userProfileSession["access"];
    setUserProfile(userProfileSession ? userProfileSession : null);
    setLoading(token ? false : true);

    dispatch(setRefreshInterval())
    // const diffToExpiery = (new Date(userProfileSession['expiery']) - new Date())/1000;
    // const refreshTimeout = diffToExpiery < 0 ? 0 : diffToExpiery - 10

    // setTimeout(() => {
    //   console.log('HH')
    //   dispatch(refreshJWT(getLoggedinUser()));
    // }, refreshTimeout)
  }, [dispatch]);


  return { userProfile, loading, token };
};

export { useProfile };
